import { useContext } from 'react';

import { TableContext } from '../context';

export const useTableContext = () => {
  return useContext(TableContext);
};
